<div class="pt-2 template-container">
    @for (template of templates; track $index) {
    <button class="btn template d-flex"
      [ngClass]="template === timelineItemContent ? 'selected-template': ''" (click)="select(template)">
      <div>
        <i class="fa-regular fa-square pe-2"></i>
        <i class="fa-regular fa-square-check pe-2"></i>
      </div>
      <div>
        {{template}}
      </div>
    </button>
    }
  </div>